import React from 'react';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import { StatusContainer } from '@/components/ui/status-container';
import { useLanguage } from '@/contexts/language-context';
import { StatusVariant } from '@/enums/status-variant';

export const PushNotificationPollingApprovedState: React.FC = () => {
  const { t } = useLanguage();

  return (
    <StatusContainer variant={StatusVariant.SUCCESS} title={t('mfa.approved')}>
      <Text as='p' size={TextSizes.MD} className='text-center text-secondary'>
        {t('mfa.redirecting')}
      </Text>
    </StatusContainer>
  );
};
